module.exports = __webpack_public_path__ + "img/icon4.72771eb7.png";